import { Module } from 'vuex'
import { IRecurly, IRootState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const recurly: Module<IRecurly, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default recurly
